import { useTheme } from "@mui/material";
import { TypographyProps } from "@mui/material";
import { OcChartProps } from "../chart/chart";

type UseOcChartSummaryProps = {
  summaryTitle: string;
  variant: OcChartProps["variant"];
};

export const useOcChartSummary = ({
  summaryTitle,
  variant,
}: UseOcChartSummaryProps) => {
  const theme = useTheme();

  const titleStyles: Record<typeof variant, TypographyProps> = {
    MyCafeteria: {
      variant: "h5",
      sx: {
        fontSize: summaryTitle.length >= 8 ? "22px" : "26px",
        lineHeight: "32px",
        letterSpacing: "0.19px",
      },
    },
    MyLeave: { variant: "h4" },
    MyTimesheet: { variant: "h5" },
  } as const;

  const subtextStyles: Record<typeof variant, TypographyProps> = {
    MyCafeteria: {
      variant: "caption",
    },
    MyLeave: { variant: "body1" },
    MyTimesheet: {
      sx: {
        color: theme.palette.darkBase.main,
      },
    },
  };

  const subtextStyle: TypographyProps = {
    ...subtextStyles[variant],
    sx: {
      textTransform: "capitalize",
      color: theme.palette.gray60.main,
      width: "100px",
      textAlign: "center",
      ...subtextStyles[variant].sx,
    },
  };

  return {
    titleStyle: titleStyles[variant],
    subtextStyle,
  };
};
